import React, { useCallback } from 'react'
import { SetStateType } from '../../definitions'

import MarkdownPreview from '../MarkdownPreview'
import style from './style.module.css'

type SectionContentMobileProps = {
  content: string
  activeSectionTitle?: string
  houseName: string
  setState: SetStateType
}

function SectionContentMobile({
  content,
  activeSectionTitle,
  houseName,
  setState,
}: SectionContentMobileProps) {
  const handleBack = useCallback(() => {
    setState(null)
  }, [setState])

  return (
    <section className={style.container}>
      <header className={style.header}>
        <i className={style.arrow} onClick={handleBack} />
        <h2 className={style.name}>{houseName}</h2>
      </header>
      <div className={style.subHeader}>
        <h1 className={style.section}>{activeSectionTitle}</h1>
      </div>

      <MarkdownPreview source={content} />
    </section>
  )
}

export default SectionContentMobile
